<template>
  <header>
    <nav class="navbar navbar-expand-md navbar-light">
      <div class="container-fluid align-items-sm-center">
        <router-link to="/Home" class="navbar-brand">
          <img :src="$t('Header.BrandLogo')" alt="Brand Logo" class="img-fluid" />
        </router-link>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbar-Nav"
          @click="toggleCollapse"
          aria-controls="navbar-Nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        ></button>

        <div :class="{ show: isCollapsed }" class="collapse navbar-collapse justify-content-end my-2" id="navbar-Nav">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <router-link to="/Home" class="nav-link text-uppercase">
                {{$t('Header.HomeTab')}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Upload" class="nav-link text-uppercase">
                {{$t('Header.UploadTab')}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Support" class="nav-link text-uppercase">
                {{$t('Header.SupportTab')}}
              </router-link>
            </li>
          </ul>

          <!-- <div class="top-social-nav">
            <ul class="list-inline m-0">
              <li>
                <a href="#" class="fb-link social-icon" title="facebook" target="_blank">
                  <i class="fab fa-facebook-square"></i>
                </a>
              </li>
              <li>
                <a href="#" class="twitter-link social-icon" title="twitter" target="_blank">
                  <i class="fab fa-square-x-twitter"></i>
                </a>
              </li>
              <li>
                <a href="#" class="ig-link social-icon" title="instagram" target="_blank">
                  <i class="fab fa-instagram-square"></i>
                </a>
              </li>
              <li>
                <a href="#" class="yt-link social-icon" title="youtube" target="_blank">
                  <i class="fab fa-youtube-square"></i>
                </a>
              </li>
            </ul>
          </div> -->
        </div>
        <div class="toogle-country-list mb-3 mb-md-0">
          <ul class="list-inline">
            <li class="active"><a :href="getLanguageLink('en')">EN</a></li>
			<li><a :href="getLanguageLink('es')">ES</a></li>
          </ul>
        </div> 
        <!-- <div class="langtoggle">
          <button @click="changeLanguage('en')" :class="{ active: currentLang === 'en' }">EN</button>
          <button @click="changeLanguage('fr')" :class="{ active: currentLang === 'fr' }">ES</button>
        </div> -->
      </div>
    </nav>
  </header>

  <banner></banner>
</template>

<script>
import banner from '../UI/Banner.vue';
export default {
  components: { banner },
  data() {
    return {
      isCollapsed: false,
      currentLang: 'en', // Initialize with default language
    };
  },
  methods: {
    changeLanguage(lang) {
      this.currentLang = lang; // Update the current language
      this.$i18n.locale = lang; // Change the i18n locale
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    
	getLanguageLink(languageCode) {
      const currentPath = this.$route.path;
      const currentHost = window.location.hostname;
      let baseUrl;

      // Determine environment based on hostname
      const isStaging = currentHost.includes('staging');

      if (languageCode === 'en') {
        baseUrl = isStaging
          ? 'https://staging-breakfastforall.snipp.us'  // Staging URL for English
          : 'https://www.breakfastforall.com';          // Production URL for English
      } else if (languageCode === 'es') {
        baseUrl = isStaging
          ? 'https://staging-esbreakfastforall.snipp.us'   // Staging URL for Spanish
          : 'https://www.es.breakfastforall.com';          // Production URL for Spanish
      }

      return `${baseUrl}${currentPath}`;
    }
  },

};
</script>

